import _sfc_main from "./DayViewInTheLast.vue2.js";
/* empty css                      */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
const DayViewInTheLast = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-40c67ef5"]]);
export {
  DayViewInTheLast as default
};
//# sourceMappingURL=DayViewInTheLast.vue.js.map
